<template>
  <v-app theme="light">
    <v-main>
      <div class="login-page">
        <section class="header-section">
          <div class="header-content">
            <img class="infinity-logo" :src="logoInfinity" alt="Infinity System Logo" />
            <h1 class="title">INFINITY SYSTEM</h1>
            <p class="subtitle">Infinitas variáveis e possibilidades</p>
            <v-row class="d-flex justify-center align-center logos-row" dense>
              <v-col cols="auto">
                <img :src="logoHbr" alt="HBR" class="partner-logo" />
              </v-col>
            </v-row>
          </div>
        </section>

        <section class="login-section">
          <v-card class="login-card" elevation="2">
            <v-form ref="loginForm" @submit.prevent="onLogin">
              <v-card-text>
                <v-text-field v-model="email" label="E-mail" prepend-icon="mdi-email" outlined dense
                  :rules="[val => !!val || 'Obrigatório']" :error="formTocado && !email" />
                <v-text-field v-model="password" :type="mostrarSenha ? 'text' : 'password'" label="Senha"
                  prepend-icon="mdi-lock" :append-icon="mostrarSenha ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="mostrarSenha = !mostrarSenha" outlined dense :rules="[val => !!val || 'Obrigatório']"
                  :error="formTocado && !password" />
              </v-card-text>

              <v-card-actions class="justify-center">
                <v-btn type="submit" class="botao-login">
                  Entrar na plataforma
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </section>
      </div>
    </v-main>
  </v-app>
</template>

<script>
  import axios from 'axios'
  import logoInfinity from '@/assets/logo_infinity.png'
  import logoHbr from '@/assets/logo_hbr.png'
  import { useTheme } from 'vuetify'

  export default {
    name: 'LoginPage',
    data() {
      return {
        email: '',
        password: '',
        rememberMe: false,
        logoInfinity,
        logoHbr,
        mostrarSenha: false,
        formTocado: false,
      }
    },
    setup() {
      const theme = useTheme()
      theme.global.name.value = 'light'
    },
    methods: {
      async onLogin() {
        this.formTocado = true;

        if (!this.email || !this.password) {
          return;
        }

        try {
          const response = await axios.post('https://infinity-refrisat.com/api/login', {
            user: this.email,
            password: this.password
          });

          if (response.data.success) {
            sessionStorage.setItem('isLogged', 'true');
            window.location.href = '/listar_equipamentos';
          } else {
            alert(response.data.message || 'Usuário ou senha incorretos.');
          }
        } catch (err) {
          console.error(err);
          alert('Falha ao fazer login.');
        }
      }
    }
  }
</script>

<style>
html,
body,
.v-application {
  background-color: #E9E9E9 !important;
  color: #333 !important;
}

html,
body,
.v-application,
.login-page {
  height: 100vh !important;
  overflow: hidden !important;
  margin: 0 !important;
  padding: 0 !important;
}

.header-section {
  background: linear-gradient(to bottom, #1f8dca, #0f5f84);
  position: relative;
  overflow: hidden;
  text-align: center;
  padding: 40px 20px;
  color: #fff;
}

.header-section::before {
  content: "";
  position: absolute;
  inset: 0;

  background: radial-gradient(circle at center,
      rgba(255, 255, 255, 0) 50%,
      rgba(255, 255, 255, 0.5) 70%,
      rgba(255, 255, 255, 0) 100%);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 110% 110%;
  animation: externalGlowPulse 6s ease-in-out infinite;

  pointer-events: none;
  z-index: 0;
}

@keyframes externalGlowPulse {

  0%,
  100% {
    background-size: 110% 110%;
  }

  50% {
    background-size: 130% 130%;
  }
}

.header-content {
  max-width: 600px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.infinity-logo {
  max-width: 240px;
  margin-bottom: 15px;
}

.title {
  font-size: 2rem;
  margin: 0;
  font-weight: bold;
}

.subtitle {
  font-size: 1.2rem;
  margin-bottom: 2rem;
}

.logos-row {
  margin-top: 20px;
}

.partner-logo {
  max-width: 80px;
  margin: 8px;
}

.login-section {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  margin-top: -5px;
}

.login-card {
  width: 400px;
  max-width: 90%;
}
</style>
